import reducer from "./reducer";
export { default as EmployeesProcesses } from "./components/index";
export { default as employeesProcessesReducerName } from "./constants";
export default reducer;
